import * as $ from 'jquery';

// TH: bootstrap npm package expects to find jquery as window.jQuery... :-(
const oldjquery = (window as any).jQuery;
(window as any).jQuery = $;
import 'bootstrap';
(window as any).jQuery = oldjquery;


// WEBPACK FOOTER //
// ./lib/twitter-bootstrap-loader.ts